import {ACTION} from './constants';

const initialState = {
}


export default function schemeReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.GET_SCHEME_CONTENT :
            return {...state, ...action.data};

        case ACTION.GET_PERFORMANCE_TAB_CONTENT :
            return {...state, performanceTab:action.data};

        case ACTION.GET_FUNDFACTS_TAB_CONTENT :
            return {...state, fundFactsTab:action.data};

        case ACTION.GET_FUNDFACTS_TAB_NAV_CONTENT :
            return {...state, fundFactsNav:action.data};

        case ACTION.GET_DOWNLOAD_TAB_CONTENT :
            return {...state, downloadTab:action.data};

        case ACTION.GET_OTHER_MANAGED_FUNDS :
            return {...state, otherManagedFunds:action.data};

        case ACTION.GET_INVESTOR_VIEWED :
            return {...state, investorViewed:action.data};
        case ACTION.GET_MIN_AMT_DETAIL :
            return {...state, minAmtDetail:action.data};

        case ACTION.CLEAR_SCHEME_CONTENT :
            return {...initialState};

        default:
            return state;
    }
}